import React, { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { markBookingReturned } from "../lib/api";
import { formatBookingDateEs } from "../lib/format";

const readCookie = (name) => {
  const item = document.cookie.split("; ").find((cookie) => cookie.startsWith(`${name}=`));
  return item ? decodeURIComponent(item.split("=")[1]) : "";
};

export default function ReadyPage() {
  const [searchParams] = useSearchParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const bookingId = searchParams.get("reserva")
    || searchParams.get("client_reference_id")
    || localStorage.getItem("wespik.booking.id")
    || readCookie("wespik_booking_id");

  const completeBooking = useCallback(() => {
    if (!bookingId) {
      setLoading(false);
      return;
    }
    markBookingReturned(bookingId)
      .then((data) => setBooking(data))
      .catch(() => setBooking(null))
      .finally(() => setLoading(false));
  }, [bookingId]);

  useEffect(() => {
    completeBooking();
  }, [completeBooking]);

  if (loading) {
    return <main className="max-w-[860px] mx-auto px-6 py-24"><div className="wk-skel" style={{ height: 220 }} /></main>;
  }

  if (!booking) {
    return (
      <main className="max-w-[860px] mx-auto px-6 py-24">
        <h1 className="text-[38px] font-extrabold tracking-hero" style={{ color: "#1E1924" }} data-testid="payment-fallback-title">
          Hemos recibido tu pago. Te escribimos en menos de 24 h.
        </h1>
        <Link className="wk-btn wk-btn-primary mt-8" to="/reservar" data-testid="payment-fallback-booking-link">
          Reservar mi primera sesión · $22
        </Link>
      </main>
    );
  }

  return (
    <main className="max-w-[860px] mx-auto px-6 py-24">
      <div className="wk-eyebrow mb-5">Reserva recibida</div>
      <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }} data-testid="payment-confirmation-title">
        Tu primera sesión ya está en marcha.
      </h1>
      <p className="mt-6 text-[17px] leading-[1.6]" style={{ color: "#70667A" }} data-testid="payment-confirmation-details">
        {booking.tutor_display_name} · {formatBookingDateEs(booking.booking_date)} · {booking.booking_time}. Confirmaremos el pago y te enviaremos los detalles de la sesión.
      </p>
      <a
        className="wk-btn wk-btn-primary mt-8"
        href={booking.private_link}
        data-testid="payment-private-link"
      >
        Abrir enlace privado de la reserva
      </a>
    </main>
  );
}